import React from "react";

const ErrorPage = () => {
  return <div>ERROR</div>;
};

export default ErrorPage;
